/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-card[_ngcontent-%COMP%]{margin:10px 20px}mat-expansion-panel[_ngcontent-%COMP%]{transition:none!important;box-shadow:none!important;width:80%;height:80%}.max-expansion-panel-header-edit[_ngcontent-%COMP%]{height:35px!important}.td.mat-cell[_ngcontent-%COMP%]{border:0;height:35px!important;padding:0!important}tr.mat-footer-row[_ngcontent-%COMP%]{height:35px!important}\n/*# sourceMappingURL=access.component.css.map*/"];
export { styles as styles };
